import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {

    //common compoents
    "DpiRegisterHomeTile": () => import("./components/DpiRegisterHomeTile.vue"),
    "CogenteRegisterHomeTile": () => import("./components/CogenteRegisterHomeTile.vue"),
    "UtilRegisterHomeTile": () => import("./components/UtilRegisterHomeTile.vue"),
    "TreatmentSingleTileContainer": () => import("./components/TreatmentSingleTileContainer.vue"),
    "TreatmentDraftDetailContainer": () => import("./components/TreatmentDraftDetailContainer.vue"),

    //Treatment drafts and Definitive Treatment
    "TreatmentDraftList": () => import("./components/tiles/TreatmentDraftList.vue"),
    "NewTreatmentDraftStepper": () => import("./components/tiles/NewTreatmentDraftStepper.vue"),
    "GeneralTreatmentDraftData": () => import("./components/treatmentDraft/GeneralTreatmentDraftData.vue"),
    "TreatmentDraftCreationMode": () => import("./components/treatmentDraft/TreatmentDraftCreationMode.vue"),
    "TreatmentHeaderDetail": () => import("./components/treatmentDraft/TreatmentHeaderDetail.vue"),
    "GeneralTreatmentDraftDataTile": () => import("./components/tiles/GeneralTreatmentDraftDataTile.vue"),
    "ModifyTreatmentHeaderTile": () => import("./components/tiles/ModifyTreatmentHeaderTile.vue"),

    //Activities Executions
    "TreatmentActivitiesExecutionsList": () => import("./components/treatmentDraft/TreatmentActivitiesExecutionsList.vue"),
    "TreatmentNewActivityExecution": () => import("./components/tiles/TreatmentNewActivityExecution.vue"),
    "TreatmentStepperContainer": () => import("./components/TreatmentStepperContainer.vue"),
    "AddPhytochemicalExecutionStepper": () => import("./components/activitiesExecutions/newActivityExecutions/phytochemicalExecution/AddPhytochemicalExecutionStepper.vue"),
    "TreatmentNewActivityExecutionSummary": () => import("./components/tiles/TreatmentNewActivityExecutionSummary.vue"),
    "TreatmentEditPhytochemicalTile": () => import("./components/tiles/TreatmentEditPhytochemicalTile.vue"),
    "TreatmentModifyActionContainer": () => import("./components/TreatmentModifyActionContainer.vue"),
    "TreatmentPhytochemicalActionStep": () => import("./components/activitiesExecutions/newActivityExecutions/phytochemicalExecution/TreatmentPhytochemicalActionStep.vue"),
    "TreatmentAddExecutionTile": () => import("./components/tiles/TreatmentAddExecutionTile.vue"),
    "TreatmentEditFertilizationTile": () => import("./components/tiles/TreatmentEditFertilizationTile.vue"),
    "TreatmentEditFormDataActionStep": () => import("./components/tiles/TreatmentEditFormDataActionStep.vue"),
    "TreatmentEditWorkersTile": () => import("./components/tiles/TreatmentEditWorkersTile.vue"),
    "TreatmentEditEquipmentTile": () => import("./components/tiles/TreatmentEditEquipmentTile.vue"),
    "TreatmentEditIrrigationTile": () => import("./components/tiles/TreatmentEditIrrigationTile.vue"),
    "TreatmentEditSeedTile": () => import("./components/tiles/TreatmentEditSeedTile.vue"),
    "RegisterDetailTile": () => import("./components/tiles/RegisterDetailTile.vue"),
    "TreatmentPhytochemicalSelectionModal": () => import("./components/tiles/TreatmentPhytochemicalSelectionModal.vue"),

    //Widget
    "TreatmentRegisterListWidget": {
        meta: {
            i18nDescrKey: "treatment-register-dpi",
            pinnable: true,
            tag: "BRG_DPI",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"]
        },
        component: () => import("./components/tiles/charts/TreatmentRegisterListWidget.vue")
    },
    "UsageRegisterListWidget": {
        meta: {
            i18nDescrKey: "treatment-registry-utilizzazioni",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "BRG_UTILIZZAZIONI"
        },
        component: () => import("./components/tiles/charts/UsageRegisterListWidget.vue")
    },

};

export default globals;
